// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { ToastContainer } from "react-toastify";
import Sentry from "../../services/sentry";
import { ReduxProvider, storeManager } from "../../services/redux";
import { Route, Router as RouterProvider, Routes } from "../../services/router";
import "react-toastify/dist/ReactToastify.css";
import * as routes from "../../config/routes";
import { ApplicationEnvironment } from "../ApplicationEnvironment";
import { ApplicationLoader } from "../ApplicationLoader";
import { ApplicationRoute } from "../ApplicationRoute";
import { ApplicationSessionContextProvider } from "../ApplicationSession";
import { ApplicationThemeContextProvider } from "../ApplicationTheme";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ApplicationPage = /*#__PURE__*/React.lazy(() => import("../ApplicationPage"));
const ApplicationAuthentication = /*#__PURE__*/React.lazy(() => import("../ApplicationAuthentication"));
export const Application = props => {
  const {
    store,
    history,
    children
  } = props;
  React.useEffect(() => {
    storeManager.store = store;
    // if (window.Cypress) {
    //   window.store = store;
    // }
  }, []);
  const content = React.useMemo(() => /*#__PURE__*/_jsxs(Routes, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: routes.authenticationLogin,
      element: /*#__PURE__*/_jsx(ApplicationRoute, {
        component: ApplicationAuthentication
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: routes.userHome,
      element: /*#__PURE__*/_jsx(ApplicationRoute, {
        component: ApplicationPage,
        authenticate: true
      })
    })]
  }), []);
  return /*#__PURE__*/_jsx(ApplicationEnvironment, {
    "data-sentry-element": "ApplicationEnvironment",
    "data-sentry-component": "Application",
    "data-sentry-source-file": "Application.tsx",
    children: /*#__PURE__*/_jsx(React.Suspense, {
      fallback: /*#__PURE__*/_jsx(ApplicationLoader, {
        type: "screen"
      }),
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "Application.tsx",
      children: /*#__PURE__*/_jsx(ReduxProvider, {
        store: store,
        "data-sentry-element": "ReduxProvider",
        "data-sentry-source-file": "Application.tsx",
        children: /*#__PURE__*/_jsx(RouterProvider, {
          history: history,
          "data-sentry-element": "RouterProvider",
          "data-sentry-source-file": "Application.tsx",
          children: /*#__PURE__*/_jsx(ApplicationSessionContextProvider, {
            "data-sentry-element": "ApplicationSessionContextProvider",
            "data-sentry-source-file": "Application.tsx",
            children: /*#__PURE__*/_jsxs(ApplicationThemeContextProvider, {
              "data-sentry-element": "ApplicationThemeContextProvider",
              "data-sentry-source-file": "Application.tsx",
              children: [children || content, /*#__PURE__*/_jsx(ToastContainer, {
                position: "bottom-right",
                draggable: false,
                "data-sentry-element": "ToastContainer",
                "data-sentry-source-file": "Application.tsx"
              })]
            })
          })
        })
      })
    })
  });
};
export default Sentry?.withProfiler(Application, {
  name: "Application"
}) || Application;